// ----------------------------------------------------------------------
// <copyright file="Izenda.DailyRecurrence.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  "use strict";

  var m = require('mobx-react');
  var React = require('react');
  var Input = require('share/components/controls/Izenda.Input');

  var DailyRecurrence = React.createClass({
    propTypes: {
      data: React.PropTypes.object
    },

    componentWillMount: function () {
      this.recurrence = this.props.data.dailyRecurrencePatternSetting;
    },
        
    /**
     * onchange every radio
     */
    onChangeEvery: function () {
      this.recurrence.isEveryWeekday = false;
      this.props.data.markDirty();
    },
        
    /**
     * get every data
     */
    getEveryInput: function () {
      return this.recurrence.recurrenceDay;
    },
        
    /**
     * onchange every input
     */
    onChangeEveryInput: function (data) {
      this.recurrence.isEveryWeekday = false;
      this.recurrence.recurrenceDay = parseInt(data.target.value, 10);
      this.props.data.markDirty();
    },
        
    /**
     * onchange every weekday radio
     */
    onChangeEveryWeekday: function () {
      this.recurrence.isEveryWeekday = true;
      this.props.data.markDirty();
    },
        
    /**
     * Render component
     */
    render: function () {
      var localizer = require('share/localization/Izenda.Localizer');

      return (
        <div>
          <div className='form-group'>
            <div className='col-md-3'>
              <Input type='radio'
                name='daily'
                checked={!this.recurrence.isEveryWeekday}
                onChange={this.onChangeEvery} /> 
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_EVERY')}</span>
            </div>
            <div className='col-md-3'>
              <Input value={this.getEveryInput() }
                onChange={this.onChangeEveryInput}
                disabled={this.recurrence.isEveryWeekday} />
            </div>
            <div className='col-md-3 control-label no-padding-left'>{localizer.getText('SUBSCRIPTION_LABEL_DAYS')}</div>
          </div>
          <div className='form-group'>
            <div className='col-md-12'>
              <Input type='radio'
                name='daily'
                checked={this.recurrence.isEveryWeekday}
                onChange={this.onChangeEveryWeekday}/> 
              <span className='radio-label'>{localizer.getText('SUBSCRIPTION_LABEL_EVERY_WEEKDAY')}</span>
            </div>
          </div>
        </div>
      );
    }
  });

  module.exports = m.observer(DailyRecurrence);
} ());


// WEBPACK FOOTER //
// ./ui/modules/Subscription/Izenda.DailyRecurrence.jsx